<template>
    <modal name="item-popup" :adaptive="true" :classes="'popup_windw'" :scrollable="true" :height="heig" :width="widt" :reset="true" @closed="$emit('popupclose')">
        <button slot="top-right"  @click="$emit('popupclose')" class="edit_button inline_display_class"><svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"/></svg></button>
        <!--</div>-->
        <div v-if="item">
            <span class="popup_header inline_display_class">{{ item.name }}</span>
        </div>
        <div id="minidelivery_popup_content" class="popup_row_container" v-if="item">
            <div class="popup_row">
                <div class="popup-image-container">
                    <img :src="image" @error="imageerror"/>
                </div>                        
            </div>
            <div class="popup_row" v-if="item.recipe || item.modifiers.length > 0">
                <pre>
{{ item.recipe }}
                </pre>
                <span v-if="item.modifiers.length > 0" class="popup_header">Дополнительно</span>
                <ModiGroup @validity="updateValidity" @modi="onModiChanged" :group="group" v-for="group in item.modifiers" :key="group.groupid" />
            </div>
        </div>
        <div id="minidelivery_popup_footer" class="popup_absbot" v-if="item">
            <SpinEdit v-model="qty" :limit="(item.rests > -1) ? item.rests : 9999" :nonzerotext="(portionsum/100).toFixed(0)" :showlimit="item.rests > -1" />
            <button @click.stop="newPortion" :disabled="!canOrder" class="spin-button">В корзину</button>
        </div>
    </modal>
</template>

<script>
import SpinEdit from './SpinEdit'
import ModiGroup from './ModiGroup'

export default {
    data(){
        return {
            qty: 1,
            modifiers:[],
            picError:false,
            modistates:{},
            canOrder: false
        }
    },
    props:['item', 'shop'],
    computed:{
        hasmodis(){
            if (this.item) {
                if (this.item.modifiers.length > 0) {
                    return true
                } else {
                    return false
                }
            } else {
                return false
            }
        },
        heig(){
            return (screen.width <= 850) ? (this.hasmodis) ? '90%' : 'auto' : '550px'
        },
        widt(){
            return (screen.width <= 850) ? '95%' : '800px'
        },
        portion(){
            return {
                code: this.item.code,
                name: this.item.name,
                qty: this.qty,
                modifiers: this.modifiers.filter(modi_item => {return modi_item.count > 0 }),
                price: this.portionprice
            }
        },
        image(){
            if (this.picError == true) {
                return this.shop.noimage
            } else {
                return this.shop.imagesurl+this.item.code+'.png'
            }
        },
        portionsum(){
            return (this.item.price + this.modifiers.filter(modi_item => {return modi_item.count > 0 }).reduce((a,b) => {return a + (b.price * b.count )}, 0) ) * this.qty
        },
        portionprice(){
            return (this.item.price + this.modifiers.filter(modi_item => {return modi_item.count > 0 }).reduce((a,b) => {return a + (b.price * b.count )}, 0) )
        },
        limited(){
            return (this.item.rests > 0) ? this.item.rests : undefined
        }
    },
    methods:{
        newPortion(){
            this.$emit('portion', this.portion)
        },
        updateValidity(data){
            this.modistates['g'+data.id] = data.value
            
            let updated = false

            for (const g of Object.entries(this.modistates)){
                if (g[1] == false) {
                    this.canOrder = false
                    updated = true
                }
            }
            if (!updated) {
                this.canOrder = true
            }
            
        },
        imageerror(){
            if (this.picError == false) {
                this.picError = true
            }
        },
        onModiChanged(modi){
            let fund = false
            
            this.modifiers = this.modifiers.map(modi_item => {
                if (modi_item.code == modi.code) {
                    modi_item = modi
                    fund = true
                }

                return modi_item
            })

            if (!fund) {
                this.modifiers.push(modi)
            }
        }
    },
    watch:{
        item(val){
            if (val) {
                this.$nextTick(
                    () => {
                        this.$modal.show('item-popup')
                    }
                )
            } else {
                this.$modal.hide('item-popup')
            }
            this.picError = false
            this.qty = 1
            this.modifiers = []
            this.modistates = {g0:true}
            this.canOrder = true
        }
    },
    components:{
        SpinEdit,
        ModiGroup
    }
}
</script>